import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Idea, IdeaInputParams } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import isUrl from 'is-url';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import wordCount from 'word-count';

import { NewIdeaService } from '../../services/new-idea.service';

@Component({
  selector: 'app-start-manually-button',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  providers: [NewIdeaService],
  templateUrl: './start-manually-button.component.html',
  styleUrl: './start-manually-button.component.scss',
})
export class StartManuallyButtonComponent {
  @Input() topic: Session;
  @Input() title: string | null;
  @Input() inputParams: IdeaInputParams;
  @Input() disabled = false;

  constructor(
    private readonly ideaService: NewIdeaService,
    private readonly messageService: MessageService,
    private readonly router: Router,
  ) {}

  private makeEvidenceFromInputUrlOrTextList(
    inputUrlOrTextList: string[],
  ): Idea['evidence'] {
    return inputUrlOrTextList.filter(Boolean).map((value, index) => {
      const citation = index + 1; // Starting from 1
      const [url, content, word_count] = isUrl(value)
        ? [value, '', null]
        : ['', value, wordCount(value)];

      return {
        citation,
        content,
        url,
        word_count,
      };
    });
  }

  handleClick() {
    const evidence =
      'inputUrlOrTextList' in this.inputParams &&
      this.makeEvidenceFromInputUrlOrTextList(
        this.inputParams.inputUrlOrTextList,
      );

    const payload = {
      inputParams: this.inputParams,
      script: '',
      shortTitle: this.title || 'Untitled',
      oneLiner: '',
      outline: '',
      evidence,
    };

    this.ideaService.save(this.topic, payload).subscribe({
      next: (createdIdea: Idea) => {
        this.router.navigate(
          ['topics', this.topic._id, 'ideas', createdIdea._id],
          {
            queryParams: { edit: true },
          },
        );
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Something went wrong.',
          detail: 'Please try change input data or try later.',
          sticky: true,
        });
      },
    });
  }
}
